export const ERROR_FEEDBACK = 'common/ERROR_FEEDBACK'